/**
 * Governance maturity labels. Current bands are the workbook's five level names
 * (Governance Maturity Model.xlsx: Initial, Repeatable, Defined, Managed, Optimizing); snapshots
 * written before the rubric used 'developing' / 'optimised' and are still shown as stored.
 */
const BAND_LABELS = {
  initial: 'Initial',
  repeatable: 'Repeatable',
  defined: 'Defined',
  managed: 'Managed',
  optimizing: 'Optimizing',
  developing: 'Developing',
  optimised: 'Optimised',
};

export function maturityBandLabel(band) {
  if (typeof band !== 'string' || !band.trim()) return null;
  return BAND_LABELS[band.trim().toLowerCase()] || band;
}
